const awsEnv = process.env.SANITY_STUDIO_AWS_ENV || "dev";

const shopApiBaseByStage: Record<string, string> = {
  dev: "https://stg09-shop.silversea.com/api",
  "dev-rx01": "https://apit.silversea.com/api-qa",
  "tst-rx": "https://apit.silversea.com/api-qa",
  "stg-rx": "https://apit.silversea.com/api-qa",
  qa: "https://shop.silversea.com/api",
  prod: "https://shop.silversea.com/api"
};

export const shopApiBaseUrl =
  shopApiBaseByStage[awsEnv] || shopApiBaseByStage.prod;
